import React from 'react';
import { Grid, Col } from 'mrf/view/Grid';
import Tooltip from './Tooltip';
import { ExcelIcon, PrinterIcon } from 'styles/components/Icons';
import store from 'mrf/redux/store';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import usePrintMode from 'mrf/utils/usePrintMode';
import { useDispatch } from 'react-redux';
import { setPrintValueAction } from 'mrf/redux/actions/print';
import { renderTableCell } from './FetcherObjectTable';
import T from 'mrf/utils/T';
import If from 'mrf/utils/If';
import { utils, writeFile } from 'xlsx';

export default function TableFooter({ fields, byId, list, csvTitle, csvUser, csvCallback, showPrintButton = true }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const printMode = usePrintMode();

    const handlePrintMode = () => {
        dispatch(setPrintValueAction(true));
    }

    const exportXlsxCallback = () => {
        const { resources } = store.getState();
        const workbook = utils.book_new();
        const headerLine = fields
            .map(f => f.name);
        
        const worksheet = utils.aoa_to_sheet([headerLine]);

        for (let i=0; i<list.length; ++i) {
            const obj = byId[list[i]];

            const csvLine = fields
                .map(field => renderTableCell({
                    t,
                    resources,
                    idx: i,
                    obj,
                    field,
                }));

            utils.sheet_add_aoa(worksheet, [csvLine], {origin: -1});
        }
        
        utils.book_append_sheet(workbook, worksheet);
        const currentTimestamp = moment(new Date()).format("YYYYMMDDhhmm");
        writeFile(workbook, `${csvTitle}_${csvUser}_${currentTimestamp}.xlsx`, {compression: true});
    }

    return (
        <div className="flex w-full pt-4 -mt-4">
            <Grid
                justify='between'
                className='w-full px-4 py-1 border-t-2 rounded-b-lg shadow-md bg-paper text-color-light'
            >
                <Col size={6} justify='start'>
                    <span className='mr-2'>
                        <T>Number of Records</T>: { list?.length }
                    </span>
                </Col>
                <Col size={6} justify='end'>
                    <If condition={!printMode}>
                        <If condition={showPrintButton}>
                            <Tooltip content='Print'>
                                <PrinterIcon size={30} onClick={handlePrintMode} id='printMode' />
                            </Tooltip>
                        </If>
                        <Tooltip content='Export XLSX'>
                            <ExcelIcon size={30} onClick={csvCallback ?? exportXlsxCallback } id='exportCsv' />
                        </Tooltip>
                    </If>
                </Col>
            </Grid>
        </div>
    );
}
